const brandStrings = {
    companyName: {
        default: {
            'en': 'Dealership Name',
            'fr': 'Nom du commerce'
        },
        dr: 'Company Name',
        cals: 'Lending Organization'
    },
    demoLabel: {
        default: {
            'en': 'What demos would you like to schedule?',
            'fr': 'Quelle démo aimeriez-vous recevoir?'
        },
        dr: 'What products would you like to schedule?'
    },
    scheduleButton: {
        default: {
            'en': 'Reserve Now',
            'fr': 'Reserve Now'
        },
        'wholesale-solutions': 'Submit',
    },
    scheduleSingleButton: {
        default: {
            'en': 'Reserve Now',
            'fr': 'Reserve Now'
        },
        mob: 'Reserve My Spot',
        'wholesale-solutions': 'Submit',
    },
    scheduleAllButton: {
        default: {
            'en': 'See All Demos',
            'fr': 'See All Demos'
        },
        dr: 'See All'
    },
    no_products: {
        default: {
            'en': 'No products available in your state',
            'fr': 'No products available in your state'
        }
    }
}

export default brandStrings;